import TimelineAction from "@app/enum/TimelineAction";

// One raw audit row carries a comma-joined action string ("record added,location changed").
const splitTimelineActions = (action: string): TimelineAction[] =>
  action.split(/\s*,\s*/) as TimelineAction[];

export default splitTimelineActions;
